<template>
   <div class="px-6 flex justify-between items-center">
         <router-link :to="'/edit/' + route.params.id"  class="flex justify-center items-center bg-g300 w-12 h-12 rounded-full text-2xl !leading-none text-white">
          <i class="ph ph-caret-left"></i>
        </router-link>
        <div class="flex-1 flex justify-center items-center pr-12">
          <p class="text-2xl font-semibold">Register Wajah</p>
        </div>
    </div>
   <pulse-loader :loading="loading" :color="color" :size="size" style="position: absolute; top: 30%;right: 45%;z-index: 99;"></pulse-loader>
  <div class="page">
    <h2>Daftar Wajah (Enroll)</h2>
     
    <CameraView ref="cameraRef" />
    
    
    <div style="z-index: 9999;margin-top: 10px;margin-top: 100px;;">
    <input v-model="employeeId" placeholder="Masukkan ID Karyawan" disabled style="display: none;"/>
    <input v-model="nama" placeholder="Masukkan Nama Karyawan" style="display: none;" />

    <br /><br />

    <button class="flex-1 py-3 bg-g300 text-white text-center rounded-xl" @click="switch_camera" style="width: 100%;">switch camera</button>
<br /><br />
    <button class="flex-1 py-3 bg-g300 text-white text-center rounded-xl" @click="enroll" style="width: 100%;">Enroll</button>
    <p>{{ status }}</p>
    </div>
  </div>

    <transition name="fade" appear>
    <div class="modal-overlay" 
         v-if="showModal" 
         @click="showModal = false"></div>
  </transition>
  <transition name="pop" appear>
    <div class="modal" 
         role="dialog" 
         v-if="showModal"
         >
      <h1>{{ status }}</h1>
      
      <button  v-if="sts"    @click="showModal = false" class="flex-1 py-3 bg-g300 text-white text-center rounded-xl font-medium border border-g300 px-6" >Check In</button>

    </div>
  </transition>


</template>

<script setup>
import { ref } from 'vue'
import CameraView from '../components/CameraView.vue'
import { useRoute } from "vue-router";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

const route = useRoute()

const employeeId = ref(route.params.id)
const nama = ref("nama")
const status = ref("")
const cameraRef = ref(null)
const loading = ref(false)
var showModal = ref(false)
 

function switch_camera(){
    cameraRef.value.switchCamera()
}

async function enroll() {
  loading.value = true;
  if (!employeeId.value) {
    status.value = "Isi ID karyawan dulu!"
    return
  }
   if (!nama.value) {
    status.value =  status.value + " Isi NAma karyawan dulu!"
    return
  }
  const dataUrl = cameraRef.value.capture()
  //const blob = await (await fetch(dataUrl)).blob()
  const formData = new FormData()
  formData.append("descriptor", dataUrl)
  formData.append("uid", employeeId.value)
  formData.append("nama", nama.value)
  formData.append("cmd", 'daftarwajah')
 
  


  const res = await fetch("https://kiyanrahayu.my.id/api2", {
    method: "POST",
    body: formData
  })

  if(res.ok){
    showModal.value = true
    status.value = 'Register sukses'
  }else{
     showModal.value = true
    status.value = 'Register Gagal'
  }
  loading.value = false;
  console.log(res)
}
</script>

 
<style scoped>
.page { padding: 20px; }

.modal {
  position: absolute;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  text-align: center;
  width: fit-content;
  height: fit-content;
  max-width: 22em;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
  background: #FFF;
  z-index: 999;
  transform: none;
}
.modal h1 {
  margin: 0 0 1rem;
}

.modal-overlay {
  content: '';
  position: absolute;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 998;
  background: #2c3e50;
  opacity: 0.6;
  cursor: pointer;
}

/* ---------------------------------- */
.fade-enter-active,
.fade-leave-active {
  transition: opacity .4s linear;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.pop-enter-active,
.pop-leave-active {
  transition: transform 0.4s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.4s linear;
}

.pop-enter,
.pop-leave-to {
  opacity: 0;
  transform: scale(0.3) translateY(-50%);
}

</style>

 